import mime from 'mime-types';
import removeLeadingSlash from 'remove-leading-slash';
require('formdata-polyfill');

export default {
  computed: {
    /**
      * API endpoint
      */
    endpoint() {
      let url = this.url;
      let requestPath = removeLeadingSlash(this.resource);
      if (requestPath != '') {
        url += `/${requestPath}`;
      }
      if (this.resourceId !== undefined) {
        url += `/${this.resourceId}`;
      }
      return url;
    },
    credentials() {
      return 'same-origin'; // TODO: Abstract this?
    },
    /**
      * Headers to send when making request
      */
    headers() {
      let headers = new Headers();
      headers.append('Accept', mime.lookup('json'));
      // Authorization
      if (this.token !== undefined && this.token != null) {
        headers.append('Authorization', `Bearer ${this.token}`);
      }
      return headers;
    }
  },
  methods: {
    /**
    * Extract data from component form element (form elements with name attributes)
    */
    formData() {
      let formData = new FormData(this.$el);
      return formData;
    },
    /**
      * Url to use when calling fetch method
      */
    fetchUrl(urlStr, formData = null, method = 'GET') {
      let url = new URL(urlStr);
      if (method == 'GET') {
        url.search = new URLSearchParams(formData);
      }
      return url;
    },
    /**
      * Options to use when calling fetch method
      */
    fetchOptions(formData = null, method = 'GET') {
      let [headers, credentials] = [
        this.headers, this.credentials
      ];
      let body = (method == 'POST') ? formData : null;
      return {headers, credentials, method, body};
    }
  }
};
